import { FormLabel } from '@src/components/ui/FormLabel';
import { useTheme } from '@src/components/ui/ThemeProvider';
import { isFormValidationError } from '@src/utilities/form';
import React from 'react';
import OTPInput from 'react-otp-input';
import { ICommonFormProps } from '../DynamicForm.types';

const Input = React.forwardRef<
    HTMLInputElement,
    React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => (
    <input
        {...props}
        ref={ref}
        className="rounded-md max-xsm:!w-[32px] max-xsm:h-[32px] !w-[45px] h-[45px] xl:!w-[60px] xl:h-[60px] border border-primary/20 bg-transparent focus-within:bg-white transition-all ease-in-out !outline-none text-primary"
    />
));

Input.displayName = 'Input';

export const FormOtpInput = React.forwardRef<HTMLDivElement, ICommonFormProps>(
    (props, ref) => {
        const { theme } = useTheme();
        const { ref: fieldRef, onChange, ...fieldProps } = props.field || {};

        return (
            <div ref={ref} className="flex flex-col gap-2.5">
                <FormLabel
                    label={props.label}
                    required={!!props.registerOptions?.required}
                />
                <div ref={fieldRef}>
                    <OTPInput
                        {...fieldProps}
                        onChange={(value: string) => onChange?.(value)}
                        containerStyle={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: props.formProps?.width || '100%',
                            maxWidth: props.formProps?.maxWidth || '400px',
                        }}
                        numInputs={props.formProps?.numInputs}
                        renderInput={(props) => <Input {...props} />}
                    />
                </div>
                {props.errors && (
                    <span
                        className="w-full font-normal text-xs text-left mt-1 "
                        style={{ color: theme.colors.error.main.text }}
                    >
                        {props.errors
                            ? isFormValidationError(props.errors.type)
                                ? props.errors?.message
                                : `${props.label} ${props.errors.type}`
                            : undefined}
                    </span>
                )}
            </div>
        );
    }
);

FormOtpInput.displayName = 'FormOtpInput';
